import PaymentGateway from '@/constants/payment-gateway'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

const useGatewayStore = defineStore('gateway', () => {
  const { t } = useI18n()

  const gateways = [
    {
      label: t('pay_with_paypal'),
      value: PaymentGateway.PAYPAL,
      image: '/images/checkout/paypal-logo.png'
    },
    {
      label: t('pay_with_bayarind'),
      value: PaymentGateway.BAYARIND,
      image: '/images/checkout/bayarind-logo.png',
      methods: [
        {
          label: t('credit_card'),
          image: '/images/checkout/bayarind-credit-card.png'
        }
      ]
    }
  ]

  const selectedGateway = ref<string>()
  const providerFees = ref<ProviderFee[]>()
  const loading = ref(false)

  const getProviderFee = (gateway: string) => {
    const provider = providerFees.value?.find((provider) => provider.name === gateway)
    if (provider) {
      return provider.fee
    }
    return 0
  }

  return {
    gateways,
    selectedGateway,
    providerFees,
    loading,
    getProviderFee
  }
})

export default useGatewayStore
